export const categories = [
  { slug: 'romance', name: '恋爱', nameEn: 'Romance', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间', color: 'bg-primary-500' },
  { slug: 'fantasy', name: '奇幻', nameEn: 'Fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻冒险世界', color: 'bg-accent-500' },
  { slug: 'action', name: '动作', nameEn: 'Action', icon: 'ri-fire-line', description: '热血沸腾的动作战斗漫画', color: 'bg-primary-500' },
  { slug: 'drama', name: '剧情', nameEn: 'Drama', icon: 'ri-emotion-line', description: '引人入胜的深度剧情故事', color: 'bg-accent-500' },
  { slug: 'comedy', name: '喜剧', nameEn: 'Comedy', icon: 'ri-emotion-happy-line', description: '轻松搞笑的日常喜剧漫画', color: 'bg-primary-500' },
  { slug: 'thriller', name: '悬疑', nameEn: 'Thriller', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理故事', color: 'bg-accent-500' },
];

export const comics = [
  {
    id: '1',
    slug: 'secret-romance',
    title: '秘密罗曼史',
    author: '金智慧',
    coverSeq: 'comic-cover-01',
    coverWidth: 800,
    coverHeight: 1140,
    description: '在首尔繁华的都市中，两个完全不同世界的人因为一次意外相遇而展开了一段秘密恋情。她是一名普通的咖啡店店员，而他却是韩国最大财阀的继承人。两人小心翼翼地隐藏着彼此的关系，却不知道更大的秘密正悄然靠近...',
    category: 'romance',
    chapters: 128,
    status: 'ongoing',
    rating: 9.6,
    views: 1280000,
    tags: ['恋爱', '都市', '财阀', '甜宠'],
    updateDate: '2026-07-02',
    chapters_list: Array.from({ length: 128 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '2',
    slug: 'magic-academy',
    title: '魔法学院的劣等生',
    author: '李东勋',
    coverSeq: 'comic-cover-02',
    coverWidth: 800,
    coverHeight: 1140,
    description: '在一个魔法至上的世界里，被判定为无魔力的少年韩宇辰，却意外进入了韩国最顶尖的魔法学院。在这里，他发现自己拥有的不是传统魔法，而是一种被遗忘的远古力量。面对歧视与挑战，他将如何证明自己的价值？',
    category: 'fantasy',
    chapters: 96,
    status: 'ongoing',
    rating: 9.4,
    views: 2150000,
    tags: ['奇幻', '学院', '成长', '逆袭'],
    updateDate: '2026-07-03',
    chapters_list: Array.from({ length: 96 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '3',
    slug: 'shadow-hunter',
    title: '暗影猎手',
    author: '朴俊秀',
    coverSeq: 'comic-cover-03',
    coverWidth: 800,
    coverHeight: 1140,
    description: '在首尔暗影之下，存在着一个人类世界未知的猎手组织。主角崔敏浩原本是一名普通的大学生，直到那个雨夜，他目睹了一场超自然的战斗。从此，他被卷入了一个充满怪物、猎人和远古秘密的世界。',
    category: 'action',
    chapters: 156,
    status: 'ongoing',
    rating: 9.7,
    views: 3420000,
    tags: ['动作', '都市', '超自然', '战斗'],
    updateDate: '2026-07-01',
    chapters_list: Array.from({ length: 156 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '4',
    slug: 'winter-tears',
    title: '冬日的眼泪',
    author: '郑恩珠',
    coverSeq: 'comic-cover-04',
    coverWidth: 800,
    coverHeight: 1140,
    description: '一个在寒冬中被遗弃的女孩，被一位年迈的画家收养。在济州岛的宁静小镇上，她逐渐找回了生活的勇气。这是一段关于治愈、成长和重新学会爱的温暖故事。',
    category: 'drama',
    chapters: 84,
    status: 'completed',
    rating: 9.5,
    views: 890000,
    tags: ['剧情', '治愈', '家庭', '成长'],
    updateDate: '2026-05-15',
    chapters_list: Array.from({ length: 84 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(6, 6 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '5',
    slug: 'office-laugh',
    title: '办公室笑传',
    author: '崔智友',
    coverSeq: 'comic-cover-05',
    coverWidth: 800,
    coverHeight: 1140,
    description: '在一家奇葩的韩国IT公司里，每天都有令人捧腹的荒唐事发生。从奇葩老板到搞笑同事，这群职场人的日常让你笑到停不下来。改编自真实职场故事。',
    category: 'comedy',
    chapters: 72,
    status: 'ongoing',
    rating: 9.2,
    views: 750000,
    tags: ['喜剧', '职场', '日常', '搞笑'],
    updateDate: '2026-06-30',
    chapters_list: Array.from({ length: 72 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '6',
    slug: 'murder-in-hongdae',
    title: '弘大杀人事件',
    author: '姜敏宇',
    coverSeq: 'comic-cover-06',
    coverWidth: 800,
    coverHeight: 1140,
    description: '首尔弘大繁华的街道上，一连串离奇的失踪案让警方束手无策。退休刑警金泰浩被卷入其中，他发现这些案件背后隐藏着一个跨越二十年的惊天秘密。每一步靠近真相，都伴随着致命的危险。',
    category: 'thriller',
    chapters: 64,
    status: 'ongoing',
    rating: 9.8,
    views: 1890000,
    tags: ['悬疑', '推理', '犯罪', '心理'],
    updateDate: '2026-06-28',
    chapters_list: Array.from({ length: 64 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '7',
    slug: 'starlight-dancer',
    title: '星光舞者',
    author: '尹素英',
    coverSeq: 'comic-cover-07',
    coverWidth: 800,
    coverHeight: 1140,
    description: '从釜山来到首尔追梦的少女舞者林多恩，在竞争激烈的舞蹈学院里遇到了志同道合的朋友和难以逾越的对手。在汗水与泪水中，她一步步向着舞台中央的聚光灯靠近。',
    category: 'drama',
    chapters: 108,
    status: 'ongoing',
    rating: 9.3,
    views: 670000,
    tags: ['剧情', '舞蹈', '青春', '追梦'],
    updateDate: '2026-07-02',
    chapters_list: Array.from({ length: 108 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '8',
    slug: 'demon-king-reborn',
    title: '魔王重生',
    author: '韩在石',
    coverSeq: 'comic-cover-08',
    coverWidth: 800,
    coverHeight: 1140,
    description: '千年之前的魔王被勇者击败后，灵魂穿越到了现代首尔，重生为一个普通的高中生。在这个没有魔法的世界里，他只想安静生活，然而命运却再次将他推向了超自然的漩涡之中。',
    category: 'fantasy',
    chapters: 112,
    status: 'ongoing',
    rating: 9.6,
    views: 2760000,
    tags: ['奇幻', '转生', '校园', '战斗'],
    updateDate: '2026-07-03',
    chapters_list: Array.from({ length: 112 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '9',
    slug: 'love-in-jeju',
    title: '济州岛之恋',
    author: '金智慧',
    coverSeq: 'comic-cover-09',
    coverWidth: 800,
    coverHeight: 1140,
    description: '被公司辞退的都市白领崔允儿，回到了故乡济州岛。在这座美丽的岛屿上，她重逢了儿时的玩伴，也重新找到了生活的意义。济州岛的海风、柑橘园和石墙小路见证了这段温暖治愈的爱情故事。',
    category: 'romance',
    chapters: 56,
    status: 'completed',
    rating: 9.1,
    views: 520000,
    tags: ['恋爱', '治愈', '海岛', '田园'],
    updateDate: '2026-04-20',
    chapters_list: Array.from({ length: 56 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(6, 6 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
  {
    id: '10',
    slug: 'sword-of-destiny',
    title: '命运之剑',
    author: '李东勋',
    coverSeq: 'comic-cover-10',
    coverWidth: 800,
    coverHeight: 1140,
    description: '在古代朝鲜的架空世界里，一把传说中的神剑重新现世。少年剑客朴武烈背负着家族的使命，踏上了寻找神剑的冒险之旅。然而，神剑的背后却隐藏着一个足以颠覆整个王朝的秘密。',
    category: 'action',
    chapters: 140,
    status: 'ongoing',
    rating: 9.5,
    views: 1980000,
    tags: ['动作', '古风', '冒险', '武侠'],
    updateDate: '2026-06-29',
    chapters_list: Array.from({ length: 140 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, date: `2026-${String(Math.max(1, Math.min(12, 7 - Math.floor(i / 4)))).padStart(2, '0')}-${String(Math.max(1, Math.min(28, 30 - (i % 4) * 7))).padStart(2, '0')}` })),
  },
];

export const banners = [
  {
    id: '1',
    comicSlug: 'shadow-hunter',
    title: '暗影猎手',
    subtitle: '首尔暗影之下，猎手觉醒',
    seq: 'banner-01',
    width: 1920,
    height: 900,
  },
  {
    id: '2',
    comicSlug: 'demon-king-reborn',
    title: '魔王重生',
    subtitle: '千年魔王，现代重生',
    seq: 'banner-02',
    width: 1920,
    height: 900,
  },
  {
    id: '3',
    comicSlug: 'magic-academy',
    title: '魔法学院的劣等生',
    subtitle: '无魔力的少年，远古的力量',
    seq: 'banner-03',
    width: 1920,
    height: 900,
  },
];

export const testimonials = [
  {
    id: '1',
    name: '漫画爱好者小明',
    avatarSeq: 'avatar-01',
    role: '忠实读者',
    content: '这个韩漫网站真的太棒了！画质清晰，加载速度也很快，下拉式阅读体验非常流畅。每天下班后都会来这里追更，已经推荐给身边所有的韩漫迷朋友了。',
    rating: 5,
  },
  {
    id: '2',
    name: '大学生小美',
    avatarSeq: 'avatar-02',
    role: '韩漫深度用户',
    content: '找了很久才找到这个网站，资源真的很全！我最喜欢的几部韩漫这里都有完整版，翻译质量也很高。阅读体验比很多同类网站都要好，界面也很清爽干净。',
    rating: 5,
  },
  {
    id: '3',
    name: '上班族阿杰',
    avatarSeq: 'avatar-03',
    role: 'VIP会员',
    content: '从第一次使用就爱上了这个平台。分类清晰，找漫画特别方便。特别喜欢它的收藏功能，追更提醒从不错过。高清画质在大屏上看漫画真的是一种享受！',
    rating: 5,
  },
  {
    id: '4',
    name: '自由职业者小花',
    avatarSeq: 'avatar-04',
    role: '资深读者',
    content: '作为一个看了十年韩漫的老读者，这个网站的阅读体验是我用过最好的。下拉式浏览非常符合手机阅读习惯，而且漫画更新速度很快，热门作品基本同步更新。',
    rating: 5,
  },
  {
    id: '5',
    name: '设计师阿凯',
    avatarSeq: 'avatar-05',
    role: '新用户',
    content: '朋友推荐来的，一用就停不下来。网站设计很有品味，广告很少不影响阅读。最重要的是漫画种类丰富，从恋爱到悬疑应有尽有，总能找到自己喜欢的类型。',
    rating: 5,
  },
];